export default __webpack_public_path__ + "static/media/linkedin.c304a414.svg";